var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"logo",attrs:{"to":_vm.to}},[_c('img',{staticClass:"logo__img",style:({ width: _vm.width + 'px' }),attrs:{"src":require(("@/assets/images/" + _vm.src)),"alt":"Logo"}})])}
var staticRenderFns = []

export { render, staticRenderFns }